export const TREND_V2_TRACKING_KEY = 'trend_v2_pending'

export interface TrendV2TrackingItem {
  messageId: string
  conversationId: string
  company: string
  startedAt: string
}
